module.exports = "https://trybtryb-legacy.web.app/img/imposter-syndrome-mobile.f96aff86.webp";